

import Vue from 'vue'
import FastClick from 'fastclick'
import VueRouter from 'vue-router'
import router from './router'
import App from './App'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import WechatPlugin from 'vux/src/plugins/wechat/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'

import {
utils
} from './S51WebGLSDK/utils/utils';
import { STORAGE_KEY } from './utils/define'
import { getCharShareInfo, getDefaultShareInfo, getJSSDK, modelView, shareHuman } from './api/api'

console.log('%c⧭', 'color: #00bf00', 22222,window.location);
let param = utils.getUrlParams(window.location.href)
console.log('url',window.location.href,param)
param.token && (param.token = decodeURIComponent(param.token));
console.log('param',param)

localStorage.setItem(STORAGE_KEY.TOKEN, param.token)
localStorage.setItem(STORAGE_KEY.MODEL_ID, param.id)


Vue.directive('transfer-dom', TransferDom)
Vue.use(VueRouter)
Vue.use(ToastPlugin)
Vue.use(WechatPlugin)
Vue.use(LoadingPlugin)

document.body.style.overflow = 'hidden';
document.body.style.position = 'fixed';
document.body.style.left = '0';
document.body.style.top = '0';











if(param.token){

if(param.type=='2d' && window.location.pathname=='/TwoD'){ //2D分享名片
getCharShareInfo(param.id).then((data)=>{
Vue.wechat.miniProgram.postMessage({
data:{
name:'setShareInfo',
msg:{
title:data.data.title,
imageUrl:data.data.image_url,
path:data.data.path
}

}
})
})
}
else if(param.type=='3d' && window.location.pathname=='/ThreeD'){ //3D分享分身
shareHuman().then(data=>{
Vue.wechat.miniProgram.postMessage({
data:{
name:'setShareInfo',
msg:{
title:data.data.title,
imageUrl:data.data.image_url,
path:`/pages/webView/webView?route=ThreeD&id=${param.id}&type=3d`
}

}
})
})
}
else{ //默认
getDefaultShareInfo().then((data)=>{
Vue.wechat.miniProgram.postMessage({
data:{
name:'setShareInfo',
msg:{
title:data.data.title,
imageUrl:data.data.image_url,
path:data.data.path
}
}
})
})
}
}



Vue.wechat.miniProgram.getEnv(res => {
if(res.miniprogram){
console.log('小程序环境：--------------')
getJSSDK(window.location.href.split('#')[0]).then(d=>{
Vue.wechat.config({
...d.data.config
})
Vue.wechat.ready((res)=>{
console.log('jssdk注册成功',res)
})
Vue.wechat.error((res)=>{
console.log('jssdk注册失败',res)
})
})
}
})


FastClick.attach(document.body)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
router,
render: h => h(App)
}).$mount('#app-box')



// WEBPACK FOOTER //
// ./src/main.js